import { render, staticRenderFns } from "./PremiumUrlBox.vue?vue&type=template&id=511d4916&scoped=true"
import script from "./PremiumUrlBox.vue?vue&type=script&lang=js"
export * from "./PremiumUrlBox.vue?vue&type=script&lang=js"
import style0 from "./PremiumUrlBox.vue?vue&type=style&index=0&id=511d4916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d4916",
  null
  
)

export default component.exports